import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import axios from "axios";
require("dotenv").config();
import "./assets/fonts/fonts.css";
import "remixicon/fonts/remixicon.css";
import {
  initSpotlight,
  initScrollReveal,
  initCounters,
} from "./plugins/motion";

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_API_HOST;

Vue.prototype.$http = axios;

// Инициализируем премиальные микроинтеракции (спотлайт на карточках, счетчики, появление)
if (typeof window !== "undefined") {
  initSpotlight();
  window.addEventListener("load", () => {
    initScrollReveal();
    initCounters();
  });
}

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
